module.exports = __webpack_public_path__ + "img/mypage.ac69d186.svg";